<section class="download">

  <div class="download-hero">
    <div class="container">
      <h1>Download</h1>
    </div>
  </div>

  <div class="container">
    <h4 class="mb-3">Download logo Promesse Viaggi</h4>

    <ul class="download-list">
      <li class="">
        <a href="https://cdn.otosrl.com/resources/promesse_viaggi/Marchio_PV_promo_variformati.zip" download>
          Logo Promozionale
        </a>
      </li>
      <li class="">
        <a>
          Logo Istituzionale
        </a>
      </li>
      <li class="">
        <a href="https://cdn.otosrl.com/resources/promesse_viaggi/LOGO_PV_3D_variformati.zip" download>
          Logo 3D
        </a>
      </li>

    </ul>
  </div>
</section>
